import { installPolyfills } from "../polyfills/installPolyfills";
export const startApp = (app) => {
    installPolyfills().then(() => app().then((x) => x()));
};

